<!--
  page:设备监控表单页面
  author:余秋桐
  date:2025-07-08
  lastEdit:2025-07-15
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="originSearch">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <!-- 类型 -->
            <a-form-item :label="language['ese.type']">
              <a-select
                v-model="typeAim"
                :options="typeList"
                :filterOption="filterOption"
                @change="changeSelectType"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 厂区 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['fd.areacode']">
              <a-select
                v-model="areaCode"
                :options="selectDataAreaCodeList"
                :filterOption="filterOption"
              ></a-select>
            </a-form-item>
          </a-col>
          <!-- 区域 -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['area']">
              <a-input
                v-model="areaLabel"
                :placeholder="language['commandCenter.title.specialAreaPlaceholder']"
                allowClear
              ></a-input>
            </a-form-item>
          </a-col>
          <!-- 运维时间 -->
          <a-col :xl="6" :lg="9" :md="10" :sm="24" v-if="typeAim === 'SPECIAL'">
            <a-form-item :label="language['commandCenter.title.operationTime']">
              <a-range-picker
                value-format="YYYY-MM-DD"
                v-model="opsDate"
                :placeholder="[
                  language['common.chooseStartDate'],
                  language['common.chooseEndDate'],
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 报修时间 -->
          <a-col :xl="6" :lg="9" :md="10" :sm="24" v-else>
            <a-form-item :label="language['commandCenter.title.repairDate']">
              <a-range-picker
                value-format="YYYY-MM-DD"
                v-model="repairDate"
                :placeholder="[
                  language['common.chooseStartDate'],
                  language['common.chooseEndDate'],
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 录入时间 -->
          <a-col :xl="6" :lg="9" :md="10" :sm="24">
            <a-form-item :label="language['commandCenter.title.inputDate']">
              <a-range-picker
                value-format="YYYY-MM-DD"
                v-model="enterDate"
                :placeholder="[
                  language['common.chooseStartDate'],
                  language['common.chooseEndDate'],
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="originSearch" icon="search">
        {{ language["common.searchButton"] }}
      </a-button>
      <a-button type="primary" @click="searchReset" icon="reload">
        {{ language["common.resetButton"] }}
      </a-button>
      <!-- 批量导入 -->
      <a-button type="primary" icon="cloud-upload" @click="openImportModal">
        {{ language["commandCenter.title.bulkImport"] }}
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ language["common.choosed"] }}
        <a style="font-weight: 600">
          {{ selectedRowKeys.length }}
        </a>
        {{ language["common.item"] }}
        <a style="margin-left: 24px" @click="onClearSelected">
          {{ language["common.clear"] }}
        </a>
        <!-- 导出功能待定 -->
        <!-- <a style="margin-left: 24px" @click="onExportSelected">{{ language['ese.export'] }}</a> -->
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="sysdeviceid"
        class="j-table-force-nowrap"
        :scroll="{ x: 1800 }"
        :dataSource="dataSource"
        :pagination="ipagination"
        :columns="columns"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="action" slot-scope="text, record">
          <a @click="openDetailModal(record)">{{ language["ispforum.details"] }}</a>
        </template>
      </a-table>
    </div>

    <!-- 批量导入弹窗 -->
    <j-modal
      :visible="showImportModal"
      :title="language['commandCenter.title.bulkImport']"
      :width="1200"
      @ok="importHandleOk"
      :ok-disabled="!modalTableShow"
      @cancel="importHandleCancel"
      :okText="language['common.submitButton']"
      :cancelText="language['fd.Basic.FmDiningroomList.guanbi']"
      :confirm-loading="modalTableLoading"
    >
      <div class="import-modal-type-choose-box">
        <div
          :class="[
            'import-modal-type-choose-item',
            importType === item.value
              ? 'import-modal-type-choose-active'
              : 'import-modal-type-choose-defalt',
          ]"
          :style="{
            borderRadius:
              index === 0 ? '6px 0 0 6px' : index === 2 ? '0px 6px 6px 0' : '',
          }"
          v-for="(item, index) in typeList"
          :key="index"
          @click="chooseImportType(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <a-steps :current="importStep" size="small" :status="stepStatus">
        <a-step :title="language['labor.fileUpload']" />
        <a-step :title="language['commandCenter.title.dataValidation']" />
        <a-step :title="language['commandCenter.title.importSubmission']" />
      </a-steps>
      <div style="height: 20px" />
      <a-upload
        :multiple="false"
        :file-list="fileList"
        :remove="handleRemove"
        :before-upload="beforeUpload"
        @change="handleChange"
      >
        <span @click.stop="() => false">
          <span style="color: red">*</span>
          {{ language["labor.fileUpload"] }}：
        </span>
        <a-button icon="cloud-upload">
          {{ language["commandCenter.title.selectFile"] }}
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 10px"
          :disabled="fileList.length === 0"
          :loading="upLoading"
          @click.stop="handleUpload"
        >
          {{
            upLoading
              ? language["commandCenter.title.uploading"]
              : language["common.uploadButton"]
          }}
        </a-button>
        <a style="margin-left: 10px" @click.stop="downloadTemplat">
          {{ language["commandCenter.title.downloadImportTemplate"] }}
        </a>
      </a-upload>
      <div class="tips-box">
        <div class="tips-title">
          {{ language["commandCenter.title.importInstructions"] }}
        </div>
        <div>1.{{ language["commandCenter.title.explain1"] }}：xlsx</div>
        <div>2.{{ language["commandCenter.title.explain4"] }}</div>
        <div>3.{{ language["commandCenter.title.explain2"] }}</div>
      </div>
      <!-- 上传报错提示 -->
      <template v-if="uploadFalseTextList.length > 0">
        <div
          class="tips-error-text"
          v-for="(item, index) in uploadFalseTextList"
          :key="index"
        >
          {{ item }}
        </div>
      </template>
      <template v-if="modalTableShow">
        <div style="height: 16px"></div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysdeviceid"
          class="j-table-force-nowrap"
          :scroll="{ x: 800, y: 500 }"
          :pagination="false"
          :dataSource="getUploadList"
          :columns="getUploadColumns"
          :loading="modalTableLoading"
        >
        </a-table>
      </template>
      <template v-if="submitShow">
        <div class="submit-box" v-if="submitStatus">
          <a-icon
            type="check-circle"
            theme="filled"
            style="color: green; font-size: 60px; margin-bottom: 10px"
          />
          <div>
            <span>导入成功，共导入</span>
            <span style="color: #3260c9; font-weight: bold">{{ submitResult }}</span>
            <span>条数据</span>
          </div>
        </div>
        <div class="submit-box" v-else>
          <a-icon
            type="close-circle"
            theme="filled"
            style="color: red; font-size: 60px; margin-bottom: 10px"
          />
          <div>
            {{ submitFalseText }}
          </div>
        </div>
      </template>
    </j-modal>

    <!-- 详情弹窗 -->
    <j-modal
      :visible="showDetailModal"
      :title="detailModalTitle"
      :width="1000"
      @cancel="detailHandleCancel"
      :footer="null"
    >
      <div class="detail-box">
        <div class="detail-item" v-for="(item, index) in detailInfo" :key="index">
          <div class="detail-left-text">
            {{ item.leftText + "：" }}
          </div>
          <div class="detail-right-text">
            {{ item.rightText() }}
          </div>
        </div>
      </div>
    </j-modal>
  </a-card>
</template>

<script>
import { getAction, postAction, downFile, uploadAction } from "@/api/manageFood";
export default {
  data() {
    return {
      areaCode: "",
      selectDataAreaCodeList: [],
      typeAim: "",
      typeList: [],
      areaLabel: "",
      opsDate: "",
      repairDate: "",
      enterDate: "",
      selectedRowKeys: [],
      selectionRows: [],
      loading: false,
      dataSource: [],
      columns: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total, range) => {
          return (
            range[0] +
            "-" +
            range[1] +
            this.$store.getters.language["common.total"] +
            total +
            this.$store.getters.language["common.strip"]
          );
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
        onShowSizeChange: (current, size) => {
          this.handlePageSizeChange(current, size);
        },
      },
      showImportModal: false,
      importStep: 0, // 0 文件上传 / 1 数据确认 / 2 导入提交
      stepStatus: "process",
      importType: "",
      fileList: [],
      upLoading: false,
      isUpload: false,
      uploadFalseTextList: [],
      getUploadList: [],
      getUploadColumns: [],
      modalTableShow: false,
      modalTableLoading: false,
      submitShow: false,
      submitStatus: false,
      submitResult: 0,
      debounce: false,
      showDetailModal: false,
      detailInfo: [],
      detailModalTitle: "",
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    // 监控设备表头
    columnsMonitoringEquipment() {
      if (this.language) {
        return [
          // 记录编号
          {
            title: this.language["commandCenter.title.recordNumber"],
            align: "center",
            width: 170,
            dataIndex: "recordno",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-all",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 类型
          {
            title: this.language["ese.type"],
            align: "center",
            width: 150,
            dataIndex: "devicetype",
            customRender: (t, r, index) => {
              return this.filterListText(this.typeList, t);
            },
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
          },
          // 厂区
          {
            title: this.language["fd.areacode"],
            align: "center",
            dataIndex: "areaname",
            width: 150,
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            customRender: (text, record) => {
              return text || "-";
            },
          },
          // 区域
          {
            title: this.language["area"],
            align: "center",
            width: 150,
            dataIndex: "position",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 异常描述
          {
            title: this.language["commandCenter.title.abnormalDescription"],
            width: 150,
            align: "center",
            dataIndex: "exception",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 报修时间
          {
            title: this.language["commandCenter.title.repairDate"],
            width: 160,
            align: "center",
            dataIndex: "repairtime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 维修完成时间
          {
            title: this.language["commandCenter.title.completionTimeOfMaintenance"],
            width: 160,
            align: "center",
            dataIndex: "repairdonetime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 预计维修完成时间
          {
            title: this.language["commandCenter.title.doneTime"],
            width: 160,
            align: "center",
            dataIndex: "expectdonetime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 维修期限/小时
          {
            title: this.language["commandCenter.title.maintenancePeriod"],
            width: 160,
            align: "center",
            dataIndex: "repairduration",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 备注
          {
            title: this.language["emp.empCmsEntrance.remark"],
            width: 160,
            align: "center",
            dataIndex: "remark",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 录入时间
          {
            title: this.language["commandCenter.title.inputDate"],
            width: 160,
            align: "center",
            dataIndex: "createdate",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 操作
          {
            title: this.language["common.action"],
            dataIndex: "action",
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: "action" },
          },
        ];
      }
    },
    // 电梯运行表头
    columnsElevatorRunning() {
      if (this.language) {
        return [
          // 记录编号
          {
            title: this.language["commandCenter.title.recordNumber"],
            align: "center",
            width: 170,
            dataIndex: "recordno",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 类型
          {
            title: this.language["ese.type"],
            align: "center",
            width: 150,
            dataIndex: "devicetype",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            customRender: (t, r, index) => {
              return this.filterListText(this.typeList, t);
            },
          },
          // 厂区
          {
            title: this.language["fd.areacode"],
            align: "center",
            dataIndex: "areaname",
            width: 150,
            customRender: (text, record) => {
              return text || "-";
            },
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
          },
          // 区域
          {
            title: this.language["area"],
            align: "center",
            width: 150,
            dataIndex: "position",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 设备编号
          {
            title: this.language["epi_device_deviceCode"],
            width: 150,
            align: "center",
            dataIndex: "devicecode",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 异常描述
          {
            title: this.language["commandCenter.title.abnormalDescription"],
            width: 160,
            align: "center",
            dataIndex: "exception",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 业主管理
          {
            title: this.language["commandCenter.title.ownerManagement"],
            width: 160,
            align: "center",
            dataIndex: "ownermanagement",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 报修时间
          {
            title: this.language["commandCenter.title.repairDate"],
            width: 160,
            align: "center",
            dataIndex: "repairtime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 通知厂家时间
          {
            title: this.language["commandCenter.title.notifyManufacturerTime"],
            width: 160,
            align: "center",
            dataIndex: "noticetime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 救援时间
          {
            title: this.language["commandCenter.title.rescueTime"],
            width: 160,
            align: "center",
            dataIndex: "helptime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 救援周期小时
          {
            title: this.language["commandCenter.title.rescueCycle"],
            width: 160,
            align: "center",
            dataIndex: "helpduration",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text.toFixed(2) || "-";
            },
          },
          // 解决方案
          {
            title: this.language["commandCenter.title.solution"],
            width: 160,
            align: "center",
            dataIndex: "solution",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 备注
          {
            title: this.language["emp.empCmsEntrance.remark"],
            width: 160,
            align: "center",
            dataIndex: "remark",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 录入时间
          {
            title: this.language["commandCenter.title.inputDate"],
            width: 160,
            align: "center",
            dataIndex: "createdate",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 操作
          {
            title: this.language["common.action"],
            dataIndex: "action",
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: "action" },
          },
        ];
      }
    },
    // 特殊区域表头
    columnsSpecialArea() {
      if (this.language) {
        return [
          // 记录编号
          {
            title: this.language["commandCenter.title.recordNumber"],
            align: "center",
            width: 170,
            dataIndex: "recordno",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 类型
          {
            title: this.language["ese.type"],
            align: "center",
            width: 150,
            dataIndex: "devicetype",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            customRender: (t, r, index) => {
              return this.filterListText(this.typeList, t);
            },
          },
          // 厂区
          {
            title: this.language["fd.areacode"],
            align: "center",
            dataIndex: "areaname",
            width: 150,
            customRender: (text, record) => {
              return text || "-";
            },
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
          },
          // 区域
          {
            title: this.language["area"],
            align: "center",
            width: 150,
            dataIndex: "position",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 标准
          {
            title: this.language["biaozhun"],
            align: "center",
            width: 150,
            dataIndex: "criteria",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 异常描述
          {
            title: this.language["commandCenter.title.abnormalDescription"],
            width: 150,
            align: "center",
            dataIndex: "exception",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 处理人
          {
            title: this.language["ese.processor"],
            width: 150,
            align: "center",
            dataIndex: "processor",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 处理结果
          {
            title: this.language["sweep_handleResult"],
            width: 150,
            align: "center",
            dataIndex: "result",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 备注
          {
            title: this.language["emp.empCmsEntrance.remark"],
            width: 160,
            align: "center",
            dataIndex: "remark",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 运维时间
          {
            title: this.language["commandCenter.title.operationTime"],
            width: 160,
            align: "center",
            dataIndex: "opstime",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 录入时间
          {
            title: this.language["commandCenter.title.inputDate"],
            width: 160,
            align: "center",
            dataIndex: "createdate",
            // 表头单元格换行配置
            customHeaderCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.3", // 适当减小行高避免文字重叠
              },
            }),
            customCell: () => {
              return {
                style: {
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
              };
            },
            // 表格body内文字处理
            customRender: (text) => {
              return text || "-";
            },
          },
          // 操作
          {
            title: this.language["common.action"],
            dataIndex: "action",
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: "action" },
          },
        ];
      }
    },
  },
  mounted() {
    this.initSearchOptions();
  },
  watch: {
    fileList(newVal) {
      // 格式处理
      let nameMirror = "";
      this.fileList.forEach((element) => {
        nameMirror = element.name.split(".")[1];
        console.log("namemirror:", nameMirror);
        if (nameMirror !== "xlsx") {
          this.handleRemove(element);
          this.$message.error(
            element.name + " " + this.language["commandCenter.title.tips1"]
          );
          return;
        }
      });

      this.getUploadList = [];
      this.getUploadColumns = [];
      this.uploadFalseTextList = [];
      this.importStep = 0;
      this.stepStatus = "process";
      this.modalTableShow = false;
      this.submitShow = false;
    },
  },
  methods: {
    originSearch() {
      this.ipagination.current = 1;
      this.searchQuery();
    },
    changeSelectType(e) {
      console.log("changeSelectType:", e);
      if (e === "SPECIAL") {
        this.opsDate = this.repairDate;
        this.repairDate = "";
      } else {
        this.repairDate = this.opsDate;
        this.opsDate = "";
      }
    },
    handleTableChange(res) {
      this.ipagination = res;
      this.searchQuery();
    },
    initModalData() {
      console.log("执行了");
      this.getUploadList = [];
      this.getUploadColumns = [];
      this.uploadFalseTextList = [];
      this.fileList = [];
      this.importStep = 0;
      this.stepStatus = "process";
      this.modalTableShow = false;
      this.submitShow = false;
    },
    // 下载模板
    downloadTemplat() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);

      let params = {
        templateType: this.importType,
      };
      console.log("importType:", this.importType);
      const fileName =
        this.filterListText(this.typeList, this.importType) +
        this.language["emp.col.templateTypeName"] +
        ".xlsx";
      downFile("FM_DEVICE/GetImportTemplate", params).then((data) => {
        console.log("导入模板：", data);
        if (!data || data.size === 0) {
          Vue.prototype["$message"].warning(
            that.$store.getters.language["common.fileDowloadError"]
          );
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(new Blob([data]), fileName);
        } else {
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    // 删除文件时调用
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      this.initModalData();
    },
    // 文件上传之前调用，返回 false 可取消上传
    beforeUpload(file) {
      // this.fileList = [...this.fileList, file];
      return false; // 返回 false 不自动上传，手动控制上传过程
    },
    // 文件状态改变时调用，比如上传中、上传完成和上传失败时
    handleChange(info) {
      console.log("*** info ***", info);
      // let fileList = [...info.fileList];
      let fileList = [info.fileList[info.fileList.length - 1]];
      // 按照服务器响应信息筛选成功上传的文件
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
    },
    // 处理弹窗内表头
    initModalTableCulmn() {
      if (this.importType === "MONITOR") {
        // 监控设备表头
        this.getUploadColumns = this.columnsMonitoringEquipment.slice(2, -2);
      } else if (this.importType === "ELEVATOR") {
        // 电梯运行表头
        this.getUploadColumns = this.columnsElevatorRunning.slice(2, -2);
      } else if (this.importType === "SPECIAL") {
        // 特殊区域表头
        this.getUploadColumns = this.columnsSpecialArea.slice(2, -2);
      }
      this.modalTableShow = true;
    },
    // 手动触发上传
    handleUpload() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);
      this.uploadFalseTextList = [];
      this.upLoading = true;
      this.modalTableShow = false;
      const formData = new FormData();
      console.log("*** fileList ***", this.fileList[0]);
      formData.append("file", this.fileList[0].originFileObj);
      formData.append("excelType", this.importType);
      uploadAction("FM_DEVICE/UploadExcel", formData)
        .then((res) => {
          this.upLoading = false;
          this.submitShow = false;
          if (res.code === 200) {
            if (res.result) {
              this.importStep = 1;
              this.getUploadList = res.result;
              this.initModalTableCulmn();
            } else {
              let falseTextList = res.message.split("\n");
              this.uploadFalseTextList = falseTextList;
            }
          }
          console.log("上传res:", res);
        })
        .catch((err) => {
          this.upLoading = false;
          this.submitShow = false;
          this.uploadFalseTextList = [this.language["commandCenter.title.tips3"]];
        });
    },
    chooseImportType(value) {
      if (this.importType === value) return;
      this.importType = value;
      this.initModalData();
    },
    importHandleCancel() {
      console.log("cancel");
      this.showImportModal = false;
      this.initModalData();
    },
    importHandleOk() {
      if (this.debounce) {
        return this.$message.warn(this.language["commandCenter.title.tips2"]);
      }
      this.debounce = true;
      setTimeout(() => {
        this.debounce = false;
      }, 1500);

      this.importStep = 2;
      this.modalTableLoading = true;
      console.log("isModalTable:", this.getUploadList);
      postAction("FM_DEVICE/ImportData", this.getUploadList)
        .then((res) => {
          this.modalTableLoading = false;
          console.log("上传提交：", res);
          this.modalTableShow = false;
          this.submitShow = true;
          if (res.success) {
            this.stepStatus = "finish";
            this.submitStatus = true;
            this.submitResult = res.result;
            this.originSearch();
          } else {
            this.submitStatus = false;
            this.submitFalseText = res.message;
          }
        })
        .catch((err) => {
          this.importStep = 2;
          this.submitShow = true;
          this.submitStatus = false;
          this.submitFalseText = "服务超时";
        });
    },
    openImportModal() {
      this.showImportModal = true;
      this.importType = this.typeAim;
    },
    openDetailModal(info) {
      console.log("*** record ***", info);
      this.detailInfo = [];
      let list = [];
      if (this.typeAim === "MONITOR") {
        // 监控设备
        this.detailModalTitle =
          this.language["commandCenter.title.monitoringEquipment"] +
          this.language["ispforum.details"];
        list = this.columnsMonitoringEquipment.slice(0, -1);
      } else if (this.typeAim === "ELEVATOR") {
        // 电梯运行
        this.detailModalTitle =
          this.language["commandCenter.title.elevatorRunning"] +
          this.language["ispforum.details"];
        list = this.columnsElevatorRunning.slice(0, -1);
      } else if (this.typeAim === "SPECIAL") {
        // 特殊区域
        this.detailModalTitle =
          this.language["commandCenter.title.specialArea"] +
          this.language["ispforum.details"];
        list = this.columnsSpecialArea.slice(0, -1);
      }
      this.detailInfo = list.map((element) => {
        return {
          leftText: element.title,
          rightText: () => {
            if (info[element.dataIndex]) {
              if (element.title === this.language["ese.type"]) {
                // 类型处理
                return this.filterListText(this.typeList, info[element.dataIndex]);
              } else if (
                element.title === this.language["commandCenter.title.rescueCycle"]
              ) {
                // 救援周期处理
                return info[element.dataIndex].toFixed(2);
              } else {
                return info[element.dataIndex];
              }
            } else {
              return "-";
            }
          },
        };
      });
      this.showDetailModal = true;
    },
    detailHandleCancel() {
      this.showDetailModal = false;
    },
    // 分页器回调
    handlePageSizeChange(current, size) {
      this.ipagination.current = current;
      this.ipagination.pageSize = size;
      this.searchQuery();
    },
    /* 列表根据code 查找文字 */
    filterListText(list, text) {
      for (let key of list) {
        if (key.value === text) {
          return key.label;
        }
      }
      return "-";
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchReset() {
      this.typeAim = this.typeList[0].value;
      this.areaCode = "";
      this.areaLabel = "";
      this.repairDate = "";
      this.enterDate = "";
      this.opsDate = "";
      this.ipagination.current = 1;
      this.searchQuery();
    },
    // 自定义搜索逻辑（按 label 匹配）
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .includes(input.toLowerCase());
    },
    initColums() {
      if (this.typeAim === "MONITOR") {
        // 监控设备表头
        this.columns = this.columnsMonitoringEquipment;
      } else if (this.typeAim === "ELEVATOR") {
        // 电梯运行表头
        this.columns = this.columnsElevatorRunning;
      } else if (this.typeAim === "SPECIAL") {
        // 特殊区域表头
        this.columns = this.columnsSpecialArea;
      }
    },
    initSearchOptions() {
      this.selectDataAreaCodeList = [
        {
          label: this.language["ipsys.all"],
          value: "",
        },
      ];
      // 类型选项卡
      this.typeList = [
        {
          label: this.language["commandCenter.title.monitoringEquipment"], // 监控设备
          value: "MONITOR",
        },
        {
          label: this.language["commandCenter.title.elevatorRunning"], // 电梯运行
          value: "ELEVATOR",
        },
        {
          label: this.language["commandCenter.title.specialArea"], // 特殊区域
          value: "SPECIAL",
        },
      ];
      // 初始化类型选项
      this.typeAim = this.typeList[0].value;
      getAction("/FMSYS/getBindingData", { dicCode: "areacode", auth: true }).then(
        (res) => {
          if (res.success) {
            this.selectDataAreaCodeList.push(...res.result);
          }
        }
      );
      this.initColums();
      this.searchQuery();
    },
    searchQuery() {
      this.loading = true;
      console.log("--- 类型---", this.typeAim);
      console.log("--- 厂区 ---", this.areaCode);
      console.log("--- 区域 ---", this.areaLabel);
      console.log("--- 报修时间 ---", this.repairDate);
      console.log("--- 录入时间 ---", this.enterDate);
      this.initColums();
      let params = {
        devicetype: this.typeAim,
        areacode: this.areaCode ? this.areaCode : "",
        position: this.areaLabel ? this.areaLabel : "",
        opstime_begin: this.opsDate ? this.opsDate[0] : "",
        opstime_end: this.opsDate ? this.opsDate[1] : "",
        repairtime_begin: this.repairDate ? this.repairDate[0] : "",
        repairtime_end: this.repairDate ? this.repairDate[1] : "",
        createdate_begin: this.enterDate ? this.enterDate[0] : "",
        createdate_end: this.enterDate ? this.enterDate[1] : "",
        PageNo: this.ipagination.current,
        PageSize: this.ipagination.pageSize,
      };
      for (const [key, value] of Object.entries(params)) {
        // 当value的值为 null || "" || undefined 时去除该键值对
        if (value === null || value === "" || value === undefined) {
          //筛选条件可根据实际情况自行调整
          Reflect.deleteProperty(params, key);
        }
      }
      const that = this;
      getAction("FM_DEVICE/list", params).then((res) => {
        console.log("*** res ***", res);
        if (res.code === 200 && res.result.records) {
          that.dataSource = res.result.records || []; // 安全访问
          that.ipagination.total = res.result.total;
        }
        that.loading = false;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .ant-steps-item-process .ant-steps-item-icon {
  background: #3260c9;
}

.detail-right-text {
  flex: 1;
  min-width: 160px;
  word-break: break-all;
  /* border: 1px solid; */
}

.detail-left-text {
  width: 40%;
  min-width: 140px;
  word-break: break-all;
  text-align: right;
  font-weight: bold;
  /* border: 1px solid; */
}

.detail-item {
  width: 46%;
  min-width: 300px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  /* border: 1px solid; */
}

.detail-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

@keyframes submitShow {
  0% {
    opacity: 0;
    top: 30px;
  }

  100% {
    opacity: 1;
    top: 0;
  }
}

.submit-box {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 20px;
  position: relative;
  animation: 0.3s submitShow;
}

.tips-error-text {
  width: 100%;
  line-height: 30px;
  text-align: center;
  color: red;
}

.tips-box {
  margin-top: 20px;
}

.tips-title {
  font-weight: bold;
}

.import-modal-type-choose-active,
.import-modal-type-choose-item:hover {
  background-color: #3260c9;
  color: #fff;
  cursor: pointer;
}

.import-modal-type-choose-defalt {
  border: 1px solid rgb(214, 214, 214);
}

.import-modal-type-choose-item {
  width: 30%;
  min-width: 100px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  transition: 0.3s;
}

.import-modal-type-choose-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
